import {getStore} from '@/services/store';

/** Saves the open review window's throttled edits now, so a verdict reads them. */
export const flushOpenReviewEdits = async (id: string): Promise<void> => {
  const tabs = (getStore().state as {
    infowindow?: {infoWindowContents?: Array<{id: unknown; content?: {updateSourceData?: () => Promise<unknown>}}>};
  }).infowindow?.infoWindowContents;
  const content = await tabs?.find((tab) => tab.id === id)?.content;
  if (content?.updateSourceData) {
    await content.updateSourceData();
  }
};
